/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_ClearInputs */

const en_live_caption_clear = /** @type {(inputs: Live_Caption_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear`)
};

const fr_live_caption_clear = /** @type {(inputs: Live_Caption_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clair`)
};

const de_live_caption_clear = /** @type {(inputs: Live_Caption_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klar`)
};

const it_live_caption_clear = /** @type {(inputs: Live_Caption_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiaro`)
};

const ru_live_caption_clear = /** @type {(inputs: Live_Caption_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прозрачный`)
};

const es_live_caption_clear = /** @type {(inputs: Live_Caption_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claro`)
};

const zh_cn2_live_caption_clear = /** @type {(inputs: Live_Caption_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`清除`)
};

const ja_live_caption_clear = /** @type {(inputs: Live_Caption_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クリア`)
};

const hi_live_caption_clear = /** @type {(inputs: Live_Caption_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्पष्ट`)
};

const pt_pt2_live_caption_clear = /** @type {(inputs: Live_Caption_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claro`)
};

/**
* | output |
* | --- |
* | "Clear" |
*
* @param {Live_Caption_ClearInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_clear = /** @type {((inputs?: Live_Caption_ClearInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_ClearInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_clear(inputs)
	if (locale === "de") return de_live_caption_clear(inputs)
	if (locale === "it") return it_live_caption_clear(inputs)
	if (locale === "ru") return ru_live_caption_clear(inputs)
	if (locale === "es") return es_live_caption_clear(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_clear(inputs)
	if (locale === "ja") return ja_live_caption_clear(inputs)
	if (locale === "hi") return hi_live_caption_clear(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_clear(inputs)
	return en_live_caption_clear(inputs)
});